import { ThemeType } from '../../utils/themes/ThemeProvider'

/**
 * The Aurora chat header renders its disclaimer subtitle (copy, links, and info icon) in the primary text/icon color
 * so it reads as part of the header rather than as secondary text. Non-Aurora headers keep the legacy secondary
 * styling because that same subtitle slot also carries non-disclaimer copy (e.g. provider portal role labels).
 */
export const getChatHeaderSubTitleColor = ({ colors, isAuroraTheme }: ThemeType): string =>
  isAuroraTheme ? colors.textPrimary : colors.textSecondary

export const getChatHeaderSubTitleLinkColor = ({ colors, isAuroraTheme }: ThemeType): string | undefined =>
  isAuroraTheme ? colors.textPrimary : undefined

export const getChatHeaderSubTitleIconColor = ({ colors, isAuroraTheme }: ThemeType): string | undefined =>
  isAuroraTheme ? colors.iconDefault : undefined
